var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6002 0.799805C2.09725 0.799805 2.5002 1.20275 2.5002 1.6998V3.59093C3.64328 2.4242 5.23666 1.6998 7.0002 1.6998C9.74466 1.6998 12.0771 3.45419 12.9415 5.89988C13.1071 6.36853 12.8615 6.88272 12.3928 7.04836C11.9242 7.214 11.41 6.96837 11.2444 6.49973C10.6262 4.75072 8.95812 3.4998 7.0002 3.4998C5.52876 3.4998 4.22103 4.20632 3.39961 5.2998H6.1002C6.59725 5.2998 7.0002 5.70275 7.0002 6.1998C7.0002 6.69686 6.59725 7.0998 6.1002 7.0998H1.6002C1.10314 7.0998 0.700195 6.69686 0.700195 6.1998V1.6998C0.700195 1.20275 1.10314 0.799805 1.6002 0.799805ZM1.60754 8.95125C2.07619 8.78561 2.59038 9.03124 2.75602 9.49988C3.37421 11.2489 5.04227 12.4998 7.0002 12.4998C8.47163 12.4998 9.77936 11.7933 10.6008 10.6998L7.9002 10.6998C7.40314 10.6998 7.0002 10.2969 7.0002 9.7998C7.0002 9.30275 7.40314 8.89981 7.9002 8.89981H12.4002C12.6389 8.8998 12.8678 8.99463 13.0366 9.16341C13.2054 9.33219 13.3002 9.56111 13.3002 9.7998V14.2998C13.3002 14.7969 12.8973 15.1998 12.4002 15.1998C11.9031 15.1998 11.5002 14.7969 11.5002 14.2998V12.4087C10.3571 13.5754 8.76373 14.2998 7.0002 14.2998C4.25573 14.2998 1.92334 12.5454 1.05891 10.0997C0.893268 9.63108 1.1389 9.11689 1.60754 8.95125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.60333658ec58910bac7d41b79234b2b7.svg";
export { ForwardRef as ReactComponent };